import { render, staticRenderFns } from "./SchemaExport.vue?vue&type=template&id=2dd78b6e&scoped=true"
import script from "./SchemaExport.vue?vue&type=script&lang=js"
export * from "./SchemaExport.vue?vue&type=script&lang=js"
import style0 from "./SchemaExport.vue?vue&type=style&index=0&id=2dd78b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd78b6e",
  null
  
)

export default component.exports